module.exports = __webpack_public_path__ + "img/marketing_map_2.c2461e59.png";